export default "__VITE_ASSET__DDSXbJA3__"